import { application } from "../entrypoints/controllers/application"
import ComponentManagerController from "./component_manager_controller"
import SortableController from "./sortable_controller"
import ClassInspectorController from "./class_inspector_controller"
import ColorPickerController from "./color_picker_controller"
import TemplateReorderController from "./template_reorder_controller"
import ProductTabsController from "./product_tabs_controller"
import MapsFlowController from "./maps_flow_controller"
import MapsPreloadController from "./maps_preload_controller"
import MapPreviewController from "./map_preview_controller"
import MarkdownEditorController from "./markdown_editor_controller"
import DesktopSidebarController from "./desktop_sidebar_controller"
import MobileTemplateBarController from "./mobile_template_bar_controller"
import DocsBuilderController from "./docs_builder_controller"
import SignupModalController from "./signup_modal_controller"
import SignupPageController from "./signup_page_controller"
import TimeBuildController from "./time_build_controller"
import TimeDemoController from "./time_demo_controller"
import DocsLibraryController from "./docs_library_controller"
import PreferencesController from "./preferences_controller"
import BusinessWalkthroughController from "./business_walkthrough_controller"
import QuoteBuilderController from "./quote_builder_controller"
import LeadFormController from "./lead_form_controller"
import BillingController from "./billing_controller"
import PlanGridController from "./plan_grid_controller"
import FeatureGateController from "./feature_gate_controller"
import FlashController from "./flash_controller"
import RedirectController from "./redirect_controller"
import LayoutGuidedController from "./layout_guided_controller"
import LayoutStartController from "./layout_start_controller"
import LayoutVenueController from "./layout_venue_controller"
import LayoutPlannerController from "./layout_planner_controller"
import VideoFacadeController from "./video_facade_controller"
import AddressLookupController from "./address_lookup_controller"

application.register("component-manager", ComponentManagerController)
application.register("sortable", SortableController)
application.register("class-inspector", ClassInspectorController)
application.register("color-picker", ColorPickerController)
application.register("template-reorder", TemplateReorderController)
application.register("product-tabs", ProductTabsController)
application.register("maps-flow", MapsFlowController)
application.register("maps-preload", MapsPreloadController)
application.register("map-preview", MapPreviewController)
application.register("markdown-editor", MarkdownEditorController)
application.register("desktop-sidebar", DesktopSidebarController)
application.register("mobile-template-bar", MobileTemplateBarController)
application.register("docs-builder", DocsBuilderController)
application.register("signup-modal", SignupModalController)
application.register("signup-page", SignupPageController)
application.register("time-build", TimeBuildController)
application.register("time-demo", TimeDemoController)
application.register("docs-library", DocsLibraryController)
application.register("preferences", PreferencesController)
application.register("business-walkthrough", BusinessWalkthroughController)
application.register("quote-builder", QuoteBuilderController)
application.register("lead-form", LeadFormController)
application.register("billing", BillingController)
application.register("plan-grid", PlanGridController)
application.register("feature-gate", FeatureGateController)
application.register("flash", FlashController)
application.register("redirect", RedirectController)
application.register("layout-guided", LayoutGuidedController)
application.register("layout-start", LayoutStartController)
application.register("video-facade", VideoFacadeController)
application.register("layout-venue", LayoutVenueController)
application.register("layout-planner", LayoutPlannerController)
application.register("address-lookup", AddressLookupController)
